import Wrapper from 'components/Wrapper';
import Text from 'components/Text';
import { ReactSVG } from 'react-svg';
import { back_icon, edit_green_icon } from 'asset/icons';
import { fontSizes } from 'appconstants';
import { Button } from 'components/ui/button';
import InputField from 'components/InputField';
import SuccessDialog from 'components/SuccessModal';
import UpdateFormLabelsFunctional from "./index.function"

const UpdateFormLabels = () => {
    const {
        selectedTab,
        setSelectedTab,
        navigate,
        setShowModal,
        showModal,
        selected_section,
        onChangeLabel,
        onPressSave,
        forms_loading
    } = UpdateFormLabelsFunctional()

    return (
        <Wrapper className='flex flex-col h-screen'>
            {/* Header */}
            <div className='flex items-center gap-3 mb-6'>
                <div
                    onClick={() => navigate(-1)}
                    className='h-10 w-10 cursor-pointer rounded-md flex items-center justify-center bg-muted hover:bg-muted/50 transition'
                >
                    <ReactSVG src={back_icon} />
                </div>
                <div>
                    <Text text={selected_section?.name} className='font-bold' size={fontSizes.h26} />
                    <Text text='Edit field labels' className='text-muted-foreground' />
                </div>
            </div>

            {/* Tabs */}
            <div className='flex gap-4 mb-5 flex-wrap'>
                {selected_section?.screens?.map((item: any) => (
                    <Button
                        disabled={selectedTab?.key === item?.key}
                        key={item?.key}
                        className={`h-10 rounded-md ${selectedTab?.key === item?.key
                            ? 'bg-primary text-white'
                            : 'bg-[rgba(110,110,115,0.2)] text-muted-foreground hover:bg-[rgba(110,110,115,0.3)]'
                            }`}
                        onClick={() => setSelectedTab(item)}
                    >
                        {item?.name}
                    </Button>
                ))}
            </div>

            {/* Form Section */}
            <div className='mt-5 rounded-xl border bg-white p-5 shadow-md mb-8 w-full max-w-[924px] space-y-5'>
                {Object.entries(selectedTab?.labels)?.map((item, index) => {
                    return (
                        <InputField
                            key={item?.[0]}
                            required
                            value={item?.[1]?.toString()}
                            rightIcon={edit_green_icon}
                            placeholder={`Enter ${item?.[1]}`}
                            onChange={(val) => onChangeLabel(val, item?.[0])}
                        />
                    )
                })}

                <Button loading={forms_loading} className='h-12 w-full rounded-xl mt-4' onClick={() => onPressSave()}>Save</Button>

                <SuccessDialog open={showModal} onContinue={() => setShowModal(false)} />
            </div>
        </Wrapper>
    );
};

export default UpdateFormLabels;
